import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button, Stack, Text } from '@stepstone-genesis/components';
import { Trans } from '@stepstone-platform/i18n';
import { useAppDispatch } from '../../../../hooks/redux/index.js';
import { sendGlobalTrackingThunk } from '../../../../core/thunks.js';
import { navigateTo } from '../../../../core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../../../types/paramsConfig.js';
import { trackButtonClick } from '../../../../tracking/index.js';
export const RegistrationFooter = () => {
    const dispatch = useAppDispatch();
    const showLogInForm = () => {
        dispatch(sendGlobalTrackingThunk(trackButtonClick, {
            uniqueName: 'switchToLogin',
        }));
        dispatch(navigateTo(FORM_TYPES.LOGIN));
    };
    return (_jsx(Stack, { direction: "vertical", spacing: "spaceM", flxItems: "center", sx: { textAlign: 'center' }, children: _jsx(Text, { fontSize: ['fontSizeS', 'fontSizeM'], "data-testid": "login-question", children: _jsx(Trans, { i18nKey: 'loginregistration.registration.haveAccount', components: [
                    _jsx(Button, { a11yLabel: "logInClick", "data-testid": "login-link", variant: 'link', onClick: showLogInForm, size: ['small', 'medium'], px: ['0px', '0px'], pb: ['2px', '1px'], sx: {
                            height: ['0px', '0px'],
                        } }, 'logInClick'),
                ] }) }) }));
};
//# sourceMappingURL=RegistrationFooter.js.map